import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import UtilContextProvider from './Contexts/UtilContext';
import "./AxiosConfig";
import ThemeProvider from './Contexts/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <ThemeProvider>
            <UtilContextProvider>
                        <App />
            </UtilContextProvider>
        </ThemeProvider>
    </BrowserRouter>
);